import { createSlice } from "@reduxjs/toolkit";
import { act } from "react";
const initialState = {
  clientsList: [],
  totalPages: 0,
  clientListById: null,
  estimatesList: [],
  estimateById: null,
  estimateAttachments: [],
  workOrdersList: [],
  workOrderItemList: [],
  workOrderDetails: null,
  partneclientsList: [],
  partnerClientById: null,
  clientsByPartnerClientsList: [],
  findClientList: [],
  clientsCount: 0,
  partnerClientsCount: 0,
  workOrdersListByCompanyId: [],
  projectsListBySubClientId: [],
  invoicesListByCompanyId: [],
};

export const ClientsSlice = createSlice({
  name: "clients",
  initialState,
  reducers: {
    setClientsList: (state, action) => {
      state.clientsList = action.payload.data;
      state.totalPages = action.payload.totalPages;
    },
    setClientDetailsById: (state, action) => {
      state.clientListById = action.payload;
    },
    resetClientDetailsById: (state) => {
      state.clientListById = null;
    },
    setEstimatesList: (state, action) => {
      state.estimatesList = action.payload.data;
      state.totalPages = action.payload.totalPages;
    },
    setEstimateById: (state, action) => {
      state.estimateById = action.payload;
      state.estimateAttachments = action.payload?.estimateAttachments;
    },
    resetEstimateById: (state) => {
      state.estimateById = null;
    },
    setEstimateAttachments: (state, action) => {
      state.estimateAttachments = action.payload;
    },
    setWorkOrdersList: (state, action) => {
      state.workOrdersList = action.payload.data;
      state.totalPages = action.payload.totalPages;
    },
    setWorkOrderItemList: (state, action) => {
      state.workOrderItemList = action.payload;
      state.totalPages = action.payload.totalPages;
    },
    setWorkOrderDetails: (state, action) => {
      state.workOrderDetails = action.payload;
    },
    resetWorkOrderDetails: (state) => {
      state.workOrderDetails = null;
    },
    setPartnerClientsList: (state, action) => {
      state.partneclientsList = action.payload.data;
      state.totalPages = action.payload.totalPages;
    },
    setPartnerClientDetailsById: (state, action) => {
      state.partnerClientById = action.payload;
    },
    resetPartnerClientDetailsById: (state) => {
      state.partnerClientById = null;
    },
    setClientsByPartnerClientsList: (state, action) => {
      state.clientsList = action.payload.data;
      state.totalPages = action.payload.totalPages;
    },
    setFindClientList: (state, action) => {
      state.findClientList = action.payload.data;
      state.totalPages = action.payload.totalPages;
    },
    resetFindClientList: (state) => {
      state.findClientList = [];
    },
    setClientsCount: (state, action) => {
      state.clientsCount = action.payload;
    },
    setPartnerClientsCount: (state, action) => {
      state.partnerClientsCount = action.payload;
    },
    setWorkOrdersListByCompanyId: (state, action) => {
      state.workOrdersListByCompanyId = action.payload.data;
      state.totalPages = action.payload.totalPages;
    },
    resetWorkOrderItems: (state) => {
      state.workOrderItemList = { items: [] };
    },
    setProjectsListBySubClientId: (state, action) => {
      state.projectsListBySubClientId = action.payload.data;
      state.totalPages = action.payload.totalPages;
    },
    setInvoicesListByCompanyId: (state, action) => {
      state.invoicesListByCompanyId = action.payload.data;
      state.totalPages = action.payload.totalPages;
    },
  },
});

export const {
  setClientsList,
  setClientDetailsById,
  resetClientDetailsById,
  setEstimatesList,
  setEstimateById,
  resetEstimateById,
  setEstimateAttachments,
  setWorkOrdersList,
  setWorkOrderItemList,
  setWorkOrderDetails,
  setPartnerClientsList,
  setPartnerClientDetailsById,
  resetPartnerClientDetailsById,
  setClientsByPartnerClientsList,
  setFindClientList,
  resetFindClientList,
  setClientsCount,
  setPartnerClientsCount,
  setWorkOrdersListByCompanyId,
  resetWorkOrderDetails,
  resetWorkOrderItems,
  setProjectsListBySubClientId,
  setInvoicesListByCompanyId,
} = ClientsSlice.actions;

export default ClientsSlice.reducer;
